import axios from "axios";
import { baseApiUrl } from "../General/Constants";

export default () => {
  return {
    getStore: async () => {
      const url = `${baseApiUrl}/customer/public/store`;

      const result = axios.get(url).then(({ data }) => ({
        data: data,
      }));
      return await result;
    },

    sendVerificationToken: (params: any) => {
      const url = `${baseApiUrl}/customer/public/user/startForgetPassword`;

      const { email } = params;

      return axios.post(url, { email }).then((data: any) => {
        if (data?.response?.status == 400) {
          throw new Error(data.data);
        }
      });
    },

    forgetPassword: (params: any) => {
      const url = `${baseApiUrl}/customer/public/user/forgetPassword`;

      const { verificationCode, password, confirmPassword } = params;

      const myHeaders = new Headers({
        "Content-Type": "application/json",
      });

      return axios
        .post(url, { verificationCode, password, confirmPassword })
        .then((data: any) => {
          if (data?.response?.status == 400) {
            throw new Error(data.data);
          }
        });
    },
  };
};
